@if (showFilter()) {
  <div class="d-flex w-100 align-content-center align-items-center mb-2 justify-content-between">
    <div>
      <bn-web-ui-datepicker
        itemStyle="secondary"
        size="xxs"
        [bsConfig]="datePickerConfig()"
        [placeholder]="'FILTER.DATE-PICKER.PLACEHOLDER' | translate"
        [readonly]="isLoading()"
        [(ngModel)]="datePickerValue"
        (ngModelChange)="onDatePickerChange($event)" />
    </div>
    <div class="d-inline-flex align-items-center">
      <bn-web-ui-button
        aria-label="Reload action"
        class="bn-button--circle"
        itemStyle="stroke"
        size="sm"
        type="button"
        [loading]="isLoading()"
        (click)="onButtonRefresh()">
        <fa-icon
          containerClass="m-1"
          icon="arrows-rotate" />
      </bn-web-ui-button>
    </div>
  </div>
}

@if (!isLoading() && logs()?.length === 0) {
  <ng-container
    *ngTemplateOutlet="
      notAvailableTemplates.logs();
      context: {
        description: 'NOT-AVAILABLE.DESCRIPTION.SHIELD_WAF-LOGS' | translate,
        show: notAvailableOptions?.show,
        noShadow: notAvailableOptions?.noShadow,
        noImage: notAvailableOptions?.noImage,
        noTitle: notAvailableOptions?.noTitle,
        noPaddingTop: notAvailableOptions?.noPaddingTop,
      }
    " />
}

@if (isLoading() || (!isLoading() && (logs()?.length || 0 > 0)) || logs() === null) {
  <div
    class="bn-table bn-table--auto bn-table--primary {{ headerSize ? 'bn-app-shield-event-log__table-header-size--' + headerSize : '' }}"
    [ngClass]="{
      'bn-app-shield-event-log__table-last-border-none': hideLastBorder,
      'bn-app-shield-event-log__table-last-border-radius': lastRowBorderRadius,
    }">
    <table class="bn-table--normal">
      @if (showHeader) {
        <thead>
          <th></th>
          <th class="whitespace-nowrap">{{ 'LABELS.DATE-TIME' | translate }}</th>
          <th class="whitespace-nowrap">{{ 'LABELS.ACTION' | translate }}</th>
          <th class="whitespace-nowrap">{{ 'LABELS.REMOTE-IP' | translate }}</th>
          <th class="whitespace-nowrap">{{ 'LABELS.RULE-ID' | translate }}</th>
          <th class="whitespace-nowrap">{{ 'LABELS.MESSAGE' | translate }}</th>
          @if (showDropdown) {
            <th></th>
          }
        </thead>
      }
      <tbody>
        @if (!isLoading() && logs() !== null) {
          @for (log of logs(); track log.logId) {
            <tr
              class="cursor-pointer color-dark-7"
              (click)="onRowToggle($index)">
              <td>
                <fa-icon [icon]="!openRows[$index] ? 'chevron-down' : 'chevron-up'" />
              </td>
              <td class="text-nowrap">{{ log.timestamp | date: dateFormat }}</td>
              <td>
                <bn-web-ui-badge
                  contentClass="text-uppercase"
                  size="sm"
                  type="tag"
                  [color]="log.labels.status === 'Logged' ? 'info' : 'danger'"
                  >{{ log.labels.status }}</bn-web-ui-badge
                >
              </td>
              <td>
                <div class="d-flex justify-content-start align-content-center align-items-center gap-2 text-nowrap">
                  <bn-web-ui-flag [countryCode]="log.labels.country" />
                  <span>{{ log.log.RemoteIp }}</span>
                </div>
              </td>
              <td
                class="no-text-wrap"
                title="{{ log.labels.ruleId }}">
                {{ log.labels.ruleId }}
              </td>
              <td
                class="simple-ellipsis"
                title="{{ log.log.Message | jsonFormat }}">
                {{ log.log.Message | jsonFormat }}
              </td>
              @if (showDropdown) {
                <td>
                  <div class="square">
                    <bn-web-ui-dropdown-menu
                      class="d-block h-100"
                      [aboveLoader]="true"
                      [items]="log | getLogDropdownItems"
                      [options]="{ align: 'end', size: 'sm', closeOnItemClick: true }"
                      (clickAction)="onDropdownClick($event)">
                      <div trigger>
                        <button
                          bn-web-ui-button
                          itemStyle="invisible"
                          [isSquare]="true">
                          <fa-icon
                            icon="ellipsis"
                            size="lg" />
                        </button>
                      </div>
                    </bn-web-ui-dropdown-menu>
                  </div>
                </td>
              }
            </tr>
            @if (!!openRows[$index]) {
              <tr class="no-hover">
                <td colspan="7">
                  <div class="row">
                    <div class="col-12 col-xl-7 pe-0 pe-xl-5">
                      <label class="text-dark-7 text-200-semi-bold mb-1">{{ 'LABELS.REQUEST-HEADERS' | translate }}</label>
                      <ul
                        class="pe-0 pe-xl-5"
                        style="max-height: 300px; overflow-y: scroll">
                        @for (header of log.log.Headers; track header) {
                          <li class="text-dark-7 mb-2">
                            <label class="text-200-semi-bold me-2">{{ header.Name }}:</label>
                            <span class="">{{ header.Value }}</span>
                          </li>
                        }
                      </ul>
                    </div>
                    <div class="col-12 col-xl-5 mt-4 mt-xl-0">
                      <div class="mb-2">
                        <label class="text-dark text-200-semi-bold">{{ 'LABELS.REQUEST-URL' | translate }}</label>
                        <div class="mt-2">
                          <a
                            bn-web-ui-button
                            class="bn-app-shield-event-log__url-button"
                            itemStyle="stroke-blue"
                            target="_blank"
                            [href]="log.log.Url"
                            [lessPadding]="true"
                            [rightIcon]="['fad', 'arrow-up-right-from-square']"
                            >{{ log.log.Url }}</a
                          >
                        </div>
                      </div>
                      <div class="mb-2 text-dark-7">
                        <label class="text-200-semi-bold me-2">{{ 'LABELS.REQUEST-METHOD' | translate }}</label>
                        <span>{{ log.labels.method }}</span>
                      </div>
                      <div class="mb-2">
                        <label class="text-dark-7 text-200-semi-bold me-2">{{ 'LABELS.REMOTE-COUNTRY-CODE' | translate }}</label>
                        <bn-web-ui-flag
                          class="d-inline-block"
                          [countryCode]="log.labels.country"
                          [displayCountryName]="true"
                          [showTooltip]="false" />
                      </div>
                      <div class="mb-2">
                        <label class="text-dark-7 text-200-semi-bold">{{ 'LABELS.ASN' | translate }}</label>
                        <div class="mt-2">
                          <a
                            bn-web-ui-button
                            href="https://ipinfo.io/AS{{ log.labels.asn }}"
                            itemStyle="stroke-blue"
                            target="_blank"
                            target="_blank"
                            [lessPadding]="true"
                            [rightIcon]="['fad', 'arrow-up-right-from-square']"
                            >{{ log.labels.asn }}</a
                          >
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="text-dark-7 text-200-semi-bold">{{ 'LABELS.REQUEST-BODY' | translate }}</label>
                        <div class="mt-2">
                          @if (log.log.UrlEncodedBody) {
                            <pre><code class="w-100" language="typescript" [highlight]="log.log.UrlEncodedBody"
                                  ></code></pre>
                          } @else {
                            <bn-web-ui-badge
                              color="blue"
                              contentClass="text-capitalize"
                              size="sm"
                              type="tag">
                              No Request Body
                            </bn-web-ui-badge>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            }
          }
        }
        @if (eventStore.isLoading() || logs() === null) {
          <ng-template *ngTemplateOutlet="skeletonTemplates.logsSkeletonTemplate(); context: { columns: 7 }" />
        }
      </tbody>
    </table>
  </div>
}

<!-- Pagination -->
@if (showPagination() && eventStore.entities().length && !isLoading()) {
  <div>
    <bn-web-ui-prev-next-pagination
      [endToken]="eventStore.endCursor()"
      [isPoweredByStore]="true"
      [leftButtonName]="'PAGINATION.LOG-BUTTONS.LEFT' | translate"
      [rightButtonName]="'PAGINATION.LOG-BUTTONS.RIGHT' | translate"
      [startToken]="eventStore.startCursor()"
      (tokenChange)="onPaginationChange($event)" />
  </div>
}

<!-- Skeleton templates -->
<bn-web-ui-table-skeleton-template #skeletonTemplates />
<!-- Not available templates -->
<bn-web-ui-not-available-template #notAvailableTemplates />
